import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import AgentRunCreate from "./AgentRunCreate";


class AgentRunList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agentRuns: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveAgentRuns();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveAgentRuns();
        }
    }

    async retrieveAgentRuns() {
        const url = 'agent_run/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                agentRuns: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.agentRuns) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Запуски агентов'}
                    url={'agent_run'}
                    data={this.state.agentRuns}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    extraComponents={[
                        {
                            component: AgentRunCreate,
                            componentProps: {}
                        }
                    ]}
                    callBack={this.retrieveAgentRuns.bind(this)}
                    fields={[
                        {
                            title: 'ID',
                            name: 'id',
                            linkPattern: '/agent_run/detail/:linkParam',
                            linkParam: 'id',
                            visible: true,
                        },
                        {
                            title: 'Агент',
                            name: 'agent.title',
                            visible: true,
                        },
                        {
                            title: 'Завершено',
                            name: 'completed',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(AgentRunList)